import { render, staticRenderFns } from "./StepA.vue?vue&type=template&id=00097e2a&scoped=true"
import script from "./StepA.vue?vue&type=script&lang=js"
export * from "./StepA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00097e2a",
  null
  
)

export default component.exports